// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  close: () => 'Close',
  error: () => 'Error',
  warn: () => 'Warning',
  info: () => 'Info',
  confirmation: () => 'Confirmation',
  progressIndeterminate: () => 'In Progress',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Between ' + p['FROM_SECTION'] + ' and ' + p['TO_SECTION'] + '.',
  indexer_disabledLabel: (p: { SECTION: string }) => p['SECTION'] + '. No matching section found.',
  indexer_othersLabel: () => '#',
  indexer_keyboardInstructionText: () => 'Press enter to select value.',
  indexer_touchInstructionText: () =>
    'Double tap and hold to enter gesture mode, then drag up or down to adjust value.',
  inputPassword_show: () => 'Show Password',
  inputPassword_hide: () => 'Hide Password',
  inputPassword_hidden: () => 'Password Hidden',
  formControl_clear: () => 'Clear',
  formControl_loading: () => 'Loading',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Maximum length ' + p['MAX_LENGTH'] + ' exceeded.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' characters left.',
  formControl_requiredMessageDetail: () => 'Enter a value.',
  select_requiredMessageDetail: () => 'Select a value.',
  select_noMatchesFound: () => 'No matches found.',
  select_oneMatchFound: () => 'One match found',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) => p['TOTAL_SIZE'] + ' matches found',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' or more matches found',
  selectMultiple_selectedValues: () => 'Selected values',
  selectMultiple_showSelectedValues: () => 'Show selected values only.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    p['VALUE_COUNT'] + ' values selected.',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Press Backspace or Delete to remove the selected value.',
  selectMultiple_apply: () => 'Apply',
  selectMultiple_back: () => 'Back',
  selector_selected: () => 'Checkbox checked',
  selector_unselected: () => 'Checkbox not checked',
  userAssistance_learnMore: () => 'Learn more',
  userAssistance_required: () => 'Required',
  filePicker_singleFileUploadError: () => 'Upload one file at a time',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    "You can't upload files of type " + p['fileType'],
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    "You can't upload files of type: " + p['fileTypes'],
  filePicker_unknownFileTypeUploadError: () => 'unknown',
  filePicker_dropzonePrimaryText: () => 'Drag and Drop',
  filePicker_dropzoneSecondaryText: () => 'Select a file or drop one here',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Select or drop files here',
  filePicker_addFiles: () => 'Add Files',
  plural_separator: () => ', ',
  inputNumber_increase: () => 'Increase',
  inputNumber_decrease: () => 'Decrease',
  inputNumber_converterParseError: () => 'Enter a number.',
  noData_message: () => 'No items to display',
  message_navigationFromMessagesRegion: () =>
    'Entering messages region. Press F6 to navigate back to prior focused element.',
  message_navigationToMessagesRegion: () =>
    'Messages region has new messages. Press F6 to navigate to the most recent message region.',
  messageToast_allMessagesClosed: () => 'All toast messages are closed.',
  expandableList_groupCollapse: () => 'Collapsed',
  expandableList_groupExpand: () => 'Expanded',
  expandableList_expandCollapseInstructionText: () => 'Use arrow keys to expand and collapse',
  list_suggestion: () => 'Suggestion',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Step ' + p['currentStep'] + ' out of ' + p['numberOfSteps'],
  train_current: () => 'Current',
  train_visited: () => 'Visited',
  train_not_visited: () => 'Not visited',
  train_message_type: () => 'Message Type',
  viz_drillable: () => 'Drillable',
  dataVisualization_stateSelected: () => 'Selected',
  dataVisualization_stateUnselected: () => 'Unselected',
  dataVisualization_noData: () => 'No data to display'
};
export default bundle;
